export const sectionsData = ["Choose your board", "Choose your trucks", "Choose your wheels", "Your skateboard"]
